export default __webpack_public_path__ + "static/media/sms.5e86a483.svg";